module.exports = __webpack_public_path__ + "media/WR Blob 16.a0c44f59.mp3";